export type MarketplaceRestoreState = {
  searchQuery: string;
  searchInput: string;
  locationSearch: string;
  selectedCategory: string;
  locationRadius: number | 'worldwide';
  locationCoords: { lat: number; lng: number } | null;
  activeTab: 'stores';
};

export type MarketplaceReturnState = {
  returnPath: string;
  hadSearch: boolean;
  restore: MarketplaceRestoreState;
};

export function buildMarketplaceReturnState(input: {
  activeTab: 'stores';
  searchQuery: string;
  searchInput: string;
  locationSearch: string;
  selectedCategory: string;
  locationRadius: number | 'worldwide';
  locationCoords: { lat: number; lng: number } | null;
}): MarketplaceReturnState {
  const hadSearch = !!(input.searchQuery.trim() || input.locationSearch.trim());
  return {
    returnPath: '/marketplace',
    hadSearch,
    restore: {
      searchQuery: input.searchQuery,
      searchInput: input.searchInput,
      locationSearch: input.locationSearch,
      selectedCategory: input.selectedCategory,
      locationRadius: input.locationRadius,
      locationCoords: input.locationCoords,
      activeTab: 'stores',
    },
  };
}
